<template>
  <canvas v-show="ready" id="totalProductType" ref="totalProductType" width="400" height="400"></canvas>
</template>

<script>
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";

const CHART_COLORS = {
  grey: "rgb(201, 203, 207)",
  blue: "rgb(54, 162, 235)",
  purple: "rgb(153, 102, 255)",
  green: "rgb(75, 192, 192)",
  yellow: "rgb(255, 205, 86)",
  orange: "rgb(255, 159, 64)",
  red: "rgb(255, 99, 132)"
};

export default {
  props: ["client_customer", "from_date", "to_date", "product", "process_type"],
  data() {
    return {
      ready: false,
      labels: [],
      data: [
        {
          label: "Kg",
          data: [],
          backgroundColor: Object.values(CHART_COLORS),
          borderWidth: 1,
          tension: 0.2,
          datalabels: {
            anchor: "start",
            formatter: function (value, context) {
              const total = context.dataset.data.reduce((a, b) => a + parseFloat(b), 0);
              return (
                new Intl.NumberFormat("es-CL").format(parseInt(value)) +
                " Kg\n" +
                ((value / total) * 100).toFixed(2) +
                "%"
              );
            }
          }
        }
      ]
    };
  },
  async mounted() {
    const self = this;
    try {
      const response = await this.$axios({
        method: "GET",
        url: `production/dashboard/process/total_product_type?client_customer=${this.client_customer}&product=${this.product}&process_type=${this.process_type}&from_date=${this.from_date}&to_date=${this.to_date}`,
        headers: {
          "Content-Type": "application/json"
        }
      });
      this.loading = false;
      this.labels = response.data.labels;
      this.data[0].data = response.data.dataset;
      this.ready = true;
    } catch (error) {
      console.log(error);
      this.loading = false;
    }

    this.ready = true;

    let ctx = this.$refs.totalProductType.getContext("2d");
    const myChart = new Chart(ctx, {
      type: "doughnut",
      data: {
        labels: this.labels,
        datasets: this.data
      },
      plugins: [ChartDataLabels],
      options: {
        maintainAspectRatio: false,
        plugins: {
          tooltip: {
            callbacks: {
              afterBody: function (context) {
                const total = context[0].dataset.data.reduce((a, b) => a + parseFloat(b), 0);
                return (
                  ((parseFloat(context[0].dataset.data[context[0].dataIndex]) / total) * 100).toFixed(2) + "% del total"
                );
              }
            }
          },
          legend: {
            display: true,
            position: "right"
          },
          datalabels: {
            color: "#043e73"
          },
          title: {
            display: true,
            align: "start",
            text: "Total tipos de producto"
          }
        },
        animation: {
          onComplete: function (animation) {
            setTimeout(() => {
              setTimeout(() => {
                self.$emit("chart-ready");
              }, 500);
            });
          }
        }
      }
    });
  }
};
</script>

<style></style>
